import { TextField } from "@kobalte/core";
import { styled } from "solid-styled-components";

export const ErrorRow = styled(TextField.ErrorMessage)`
  color: ${({ theme }) => theme?.colors.error};
  font-size: 14px;
  padding: 5px 0 0 15px;
`;
